exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /Volumes/Box/sites/wandsworthhub/app/bedrock/web/app/themes/wandsworthhub/node_modules/core-js/internals/object-get-own-property-symbols.js
// module id = 114
// module chunks = 0